export default {
  FUNCTIONS_TABLE: {
    FUNCTION:
      "The function's name, or API name in case it's a function that only serves one endpoint",
    API: 'The API endpoints pointing at this function',
    RUNS: 'Total number of invocations in the selected timeframe, with average per day in brackets (if timeframe is ≥ 1 day).',
    RUNS_TREND:
      'The trend change in how many times the function is invoked in the selected timeframe',
    DURATION: 'The average duration of the function',
    DURATION_TREND: 'The trend change in the average duration of the function',
    ERRORS: 'The % of function invocations where it throws an exception',
    ERRORS_TREND:
      'The trend change in the % of function invocations where it throws an exception',
    COST: 'The estimated annualized compute cost of the function',
    LAST_INVOKED: 'How long ago was the function last invoked',
    LAST_CHANGED:
      "How long ago was the function's last code change in the selected environment",
    FIRST_MAPPED:
      'When was the function first mapped in the selected environment',
    FILE_PATH: "The function's file path",
    SERVICES: 'The services in which the function runs',
    LANGUAGE:
      'The runtime language used by the service that executes the function',
  },
  SERVICES_TABLE: {
    NAME: 'Service name',
    STATE:
      "Running: the service is currently active.\nIdle: the service hasn't been running in the past 30 minutes.",
    FUNCTIONS_MAPPED:
      'The number of functions mapped in the service in the selected environment',
    FUNCTIONS_INVOKED:
      'The number of functions invoked in the service in the selected environment',
    LAST_SEEN: 'How long ago the service last communicated',
    COST: 'The estimated annualized compute cost of the service',
    MY_SERVICES:
      'Choose the services relevant to you, they will appear by default in My Services across all of Hud.',
    ADD_TO_MY_SERVICES: 'Add to My Services',
    REMOVE_FROM_MY_SERVICES: 'Remove from My Services',
  },
  ENDPOINTS_TABLE: {
    PATH: 'The endpoint path',
    METHODS: 'The HTTP methods the endpoint supports',
    SERVICES: 'The services in which the endpoint runs',
    RUNS: 'Total number of invocations in the selected timeframe, with average per day in brackets (if timeframe is ≥ 1 day).',
    RUNS_TREND:
      'The trend change in how many times the endpoint is invoked in the selected timeframe',
    DURATION: 'The average duration of the endpoint',
    AVG_DURATION_TREND:
      'The trend change in the average duration of the endpoint',
    DURATION_P90: 'The P90 duration of the endpoint',
    DURATION_P90_TREND:
      'The trend change in the 90th percentile duration of the endpoint',
    ERRORS:
      'The % of endpoint invocations where the returned status code is greater than 500',
    ERRORS_TREND:
      'The trend change in the % of endpoint invocations where the returned status code is greater than 500',
    LAST_INVOKED: 'How long ago was the endpoint last invoked',
  },
  MESSAGE_QUEUES_TABLE: {
    TITLE: 'The message queue or topic name, including the consumer group ID if applicable',
    TYPE: 'The type of messaging system',
    SERVICE: 'The service where the messaging system operates',
    RUNS: 'Total number of times the messaging system processes messages or batches in the selected timeframe, with average per day in brackets (if timeframe is ≥ 1 day).',
    RUNS_TREND:
      'The trend change in how often the messaging system processes messages in the selected timeframe',
    E2E_DURATION:
      'The average time from when a message enters the queue or topic until it is fully consumed',
    E2E_DURATION_P90: 'The 90th percentile duration for message processing from entry to consumption',
    AVG_E2E_DURATION_TREND:
      'The trend change in the average time taken for a message to be processed from entry to consumption',
    P90_E2E_DURATION_TREND:
      'The trend change in the 90th percentile duration for a message to be processed from entry to consumption',
    PROCESSING_DURATION:
      'The average time from when a message is pulled from the queue or topic until it is fully consumed',
    PROCESSING_DURATION_P90: 'The 90th percentile duration for message processing after being pulled from the queue or topic',
    PROCESSING_P90_DURATION_TREND:
      'The trend change in the 90th percentile duration for a message to be processed after being pulled from the queue or topic',
    AVG_PROCESSING_DURATION_TREND:
      'The trend change in the average time taken for a message to be processed after being pulled from the queue or topic',
    ERRORS: 'The percentage of message processing attempts that result in an exception',
    MSG_COUNT: 'The number of messages processed per day',
    ERRORS_TREND:
      'The trend change in the percentage of message processing attempts that result in an exception',
    LAST_INVOKED: 'The time elapsed since the queue or topic was last processed',
  },
};
